/**
 * A member's face: the photo when there is one and it loads, otherwise their
 * initials on the muted surface.
 *
 * @module components/settings/MemberAvatar
 */
import { useState } from "react";

import { cn } from "../../lib/utils";
import type { OrgTeamMember } from "../../state/orgProfile";
import { Avatar, AvatarFallback, AvatarImage, personInitials } from "../ui/avatar";
import { memberDisplayName } from "./orgMembers.logic";

export function MemberAvatar({
  member,
  className,
}: {
  readonly member: Pick<OrgTeamMember, "name" | "email" | "avatarUrl">;
  readonly className?: string;
}) {
  const [broken, setBroken] = useState<string | null>(null);
  const photo = member.avatarUrl && member.avatarUrl !== broken ? member.avatarUrl : null;
  return (
    <Avatar className={cn("size-8", className)}>
      {photo ? (
        <AvatarImage
          src={photo}
          alt={`${memberDisplayName(member)} avatar`}
          onError={() => setBroken(photo)}
        />
      ) : (
        <AvatarFallback className="text-[11px] font-medium text-muted-foreground">
          {personInitials({ name: member.name, email: member.email })}
        </AvatarFallback>
      )}
    </Avatar>
  );
}
